import * as actionTypes from "constants/actionTypes";

export function createGoal(name, conditions, stepId) {
  return {
    type: actionTypes.CREATE_GOAL,
    payload: {
      conditions,
      name,
      stepId
    }
  };
}

export function updateGoalAndFlushGoal(goalId, changes) {
  return {
    ...updateGoalInStore(goalId, changes),
    type: actionTypes.UPDATE_GOAL_AND_FLUSH_GOAL
  };
}

export function updateGoalInStore(goalId, changes) {
  return {
    type: actionTypes.UPDATE_GOAL_IN_STORE,
    payload: {
      goalId,
      changes
    }
  };
}

export function activateGoal(goal) {
  return updateGoalAndFlushGoal(goal.id, {
    disabled: null,
    enabledTs: [...(goal.enabledTs || []), Date.now()]
  });
}

export function deactivateGoal(goal) {
  return updateGoalAndFlushGoal(goal.id, {
    disabled: true,
    disabledTs: [...(goal.disabledTs || []), Date.now()]
  });
}

export function deleteGoalAndFlushGoal(goalId) {
  return {
    type: actionTypes.DELETE_GOAL_AND_FLUSH_GOAL,
    payload: {
      goalId
    }
  };
}
